import React from 'react';
import moment from "moment-mini"
import { useEffect } from "react"
import type { GroupMessageProps, GroupPlayerProps, GroupProps, PublicPlayerProps } from "../../types"
import { useColors } from "../../constants/useColors"
import { Button, Text, View } from "../../Components/Themed"
import { Icons } from '../../Components';
import { Image, type ViewStyle } from 'react-native';

type GroupCTAButtonProps = {
    group:GroupProps,
    style?:ViewStyle,
    hide_from_player?:boolean,
    message_length?:number,
    group_messages:GroupMessageProps[],
    players:PublicPlayerProps[],
    group_players:GroupPlayerProps[],
    onSelectChat:(group:GroupProps) => void
}

const GroupCTAButton = ({ group, style, players, hide_from_player, message_length, group_messages, onSelectChat }:GroupCTAButtonProps) => {
    const Colors = useColors();

    useEffect(( ) => {
        if(!group){ return }
        //setUpCta();
    },[group.group_id]);


    let last_message = group_messages.sort((a,b) => moment(b.create_datetime).unix() - moment(a.create_datetime).unix())[0]
    let cta_message = group.name
    if(last_message?.message){ cta_message = `${last_message.message.slice(0, message_length ?? 15)}...` }
    const last_player = players.find(p => p.player_id == last_message?.player_id)
    return (
        <View float style={{ ...style }}>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => onSelectChat(group)}>
                <View transparent style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                    <Icons.ChatIcon size={16} color={Colors.text.h1}/>
                </View>
                {last_player ?
                <Image
                    source={{ uri: last_player.profile_pic }}
                    style={{ height:22, width:22, borderRadius:100 }}
                    resizeMode='contain'
                />
                :<></>}
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h2'>{cta_message}</Text>
                    {last_player && !hide_from_player ?
                    <Text theme='description' style={{ marginTop:3 }}>@{last_player.username}</Text>
                    :<></>}
                </View>
                 
            </Button>
        </View>

    )
}
export default GroupCTAButton